import { Dispatch, FC, SetStateAction } from 'react';
import { CardReference } from './AssignmentMonitoringCards';

interface Props {
  cardInfo: CardReference;
  setSelectedCard: Dispatch<SetStateAction<CardReference | null>>;
  assignmentProgressPercentages: number;
}

export const AssignmentStudentPercentageCard: FC<Props> = ({
  cardInfo,
  setSelectedCard,
  assignmentProgressPercentages,
}) => {
  return (
    <div
      onClick={() => setSelectedCard(cardInfo)}
      className="w-10rem h-11rem shadow-none flex flex-column align-items-center justify-content-center overflow-hidden border-2 border-round-lg border-link-light pt-0 mx-2 cursor-pointer"
      key={cardInfo.key}
    >
      <i className={`${cardInfo.icon} icon-sm text-primary`} />
      <p className="py-0 my-0 h-2rem">{cardInfo.label}:</p>
      <p className="py-0 my-0 font-medium text-lg">{assignmentProgressPercentages}%</p>
    </div>
  );
};
